export default __webpack_public_path__ + "static/media/research3.1044e83e.jpg";